import React, { useState, useEffect } from "react"; 
import { useParams,Link } from "react-router-dom";
import "../pages/Gallery.css"

function FolderPage() {
  const { folderName } = useParams();
 const [data, setData] = useState([]);

  useEffect(() => {
    fetch("https://socalfurs.com/socal_meetup_images.php")
      .then((response) => response.json())  
      .then(data => {
        setData(data.photos); 
      })
      .catch((error) => console.error("Error fetching data:", error)); 
  }, []);

const slugify = (str) =>
  str.toLowerCase()
     .replace(/[^a-z0-9]+/g, '-')   // replace spaces & special chars
     .replace(/(^-|-$)/g, '');      // trim dashes



  const folders = data.map(item => {
  let images = [];

  try {

    if (typeof item.folder_ids === "string") 
    {
      images = JSON.parse(item.folder_ids);

    } else if (Array.isArray(item.folder_ids)) 
      
    {
      images = item.folder_ids;
    }
  } catch (e) {
    console.error("Bad JSON:", item.folder_ids);
  }
//  const folders = data.map(item => ({
//   folderName: item.folder_name,
//   images: JSON.parse(item.folder_ids)  // convert string → array
  
// }));

  return {
    folderNameOriginal: item.folder_name,
    folderNameSlug: slugify(item.folder_name),
    images: JSON.parse(item.folder_ids) || null
  };
});


console.log("FOLDER DATA:  ",folders)
  console.log(data)


  return (
    
    
<div className ="gallery-folder-container">

  <div className = "padding-gallery">
   
  </div>


  
    {folders
      .filter(folder => folder.folderNameSlug === folderName)
      .map(folder => (
        <div key={folder.folderNameOriginal}>
                <div className = "photo-header-container">

            <h1 className = "photo-header">{folder.folderNameOriginal}</h1>
            <div class="my-line"></div>

        </div>

        <div className =""> 

          <ul className = "ul-event">



                                 {folder.images && folder.images.length > 0 ? (
            folder.images.map((image, index) => (
              <li className = "" key = {folder.folderNameOriginal}>
                <div className = "space-gallery"></div>
                  <div className = "outer-big">
                    <div className = "outer-gallery">
                         <img
                          key={index}
                          style={{ width: "200px", height: "200px" }}
                          src={`https://socalfurs.com/socal_meetup_images/${folder.folderNameOriginal}/${image}`}
                          alt={folder.folderNameOriginal}
                        />
                    </div>
                  </div>
              
              </li>
              
            ))
          ) : (
            <p>No images found.</p>
          )}
            </ul>
        </div>
        
            
   
        </div>
      ))}
  </div>
  );
}

export default FolderPage;
